import { QueryWrapperNext } from '@diamond/shared/data-access';
import { ShipTo } from '@diamond/shared/types';

import { useAuthStore } from '../stores';

export function useUserShipTos() {
  const session = useAuthStore();
  const queryShipTo = QueryWrapperNext('/account', session.access_token);
  const { data: shipTos } = queryShipTo.useQueryGetById<ShipTo>(
    `${session.userId}/ship-to`,
    'ShipTo'
  );

  return { shipTos };
}

export default useUserShipTos;
